import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  height: 100%;
  max-height: 14rem;

  img {
    height: 2.2rem;
  }
`;
